import { render, staticRenderFns } from "./SubjectSuggestion.vue?vue&type=template&id=f973894a&scoped=true"
import script from "./SubjectSuggestion.vue?vue&type=script&lang=js"
export * from "./SubjectSuggestion.vue?vue&type=script&lang=js"
import style0 from "./SubjectSuggestion.vue?vue&type=style&index=0&id=f973894a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f973894a",
  null
  
)

export default component.exports